import { apiFetch } from "./index";
import {
  userLicenseResponseSchema,
  stripeCheckoutResponseSchema,
  stripeBillingPortalResponseSchema,
  type UserLicense,
} from "./schemas";

export async function getCurrentLicense(): Promise<UserLicense> {
  const { data } = await apiFetch(
    "/api/v2/user_license/current",
    {
      method: "GET",
      headers: {
        "Accept": "application/json",
      },
    },
    userLicenseResponseSchema
  );
  return data.license;
}

export async function createCheckoutSession(): Promise<{ checkout_url: string; session_id: string }> {
  const { data } = await apiFetch(
    "/api/v2/user_license/create_checkout_session",
    {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
    },
    stripeCheckoutResponseSchema
  );
  return data;
}

export async function getBillingPortalUrl(): Promise<{ portal_url: string }> {
  const { data } = await apiFetch(
    "/api/v2/user_license/billing_portal",
    {
      method: "GET",
      headers: {
        "Accept": "application/json",
      },
    },
    stripeBillingPortalResponseSchema
  );
  return data;
}
